import { ref, computed, watch, onMounted } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { useNovaPoshta, useValidationRules } from '~/composables';


export default {
  __name: 'ServiceFormNovaPoshtaFields',
  props: {
  selectedCountry: {
    type: [String, Number],
    default: null,
  },
},
  emits: ['change', 'countries-loaded'],
  setup(__props, { expose, emit }) {

const props = __props;





const getFullAddressStringFromAddressObj = (addressObj) => addressObj.address;

const cityAutocompleteRef = ref();
const autocompleteRef = ref();

const searchedCity = ref('');
const searchedAddress = ref('');
const fullAddress = ref('');
const selectedCityId = ref(null);

const npProvider = useNovaPoshta();

const citySuggestions = computed(() => npProvider.cities.value);
const addressSuggestions = computed(() => npProvider.pickupPoints.value);
const isCitiesLoading = computed(
  () => npProvider.isCitiesLoading?.value || false,
);
const isLocationsLoading = computed(
  () => npProvider.isPickupPointsLoading.value,
);

const { required, addressRules, errorMessages } = useValidationRules();

const v$ = useVuelidate(
  {
    searchedCity: { required },
    searchedAddress: addressRules(
      addressSuggestions,
      fullAddress,
      getFullAddressStringFromAddressObj,
    ),
  },
  { searchedCity, searchedAddress },
);

const isAddressSelectDisabled = computed(() => {
  return !selectedCityId.value;
});

const handleCityInput = (value) => {
  searchedCity.value = value;
  v$.value.searchedCity.$touch();
};

const handleAddressInput = (value) => {
  searchedAddress.value = value;
  v$.value.searchedAddress.$touch();
};

const searchCity = async (event) => {
  searchedCity.value = event.query;
  await npProvider.getCities(event.query);
};

const searchAddress = async (event) => {
  searchedAddress.value = event.query;
  if (selectedCityId.value) {
    await npProvider.getPickupPoints(selectedCityId.value, event.query);
  }
};

const handleSelectCity = (event) => {
  searchedCity.value = event.value.title;
  selectedCityId.value = event.value.id;
  searchedAddress.value = '';
  fullAddress.value = '';
};

const handleSelectAddress = (event) => {
  const selectedFullAddress = getFullAddressStringFromAddressObj(event.value);
  searchedAddress.value = selectedFullAddress;
  fullAddress.value = selectedFullAddress;

  const cityData = citySuggestions.value.find(
    (c) => selectedCityId.value === c.id,
  );
  const cityTitle = cityData?.title || '';

  emit('change', {
    fieldName: 'fullAddress',
    fieldValue: `${cityTitle}, ${selectedFullAddress}`,
  });
};

onMounted(() => {
  emit('countries-loaded', npProvider.countries.value);
});

watch(
  () => props.selectedCountry,
  () => {
    searchedCity.value = '';
    searchedAddress.value = '';
    fullAddress.value = '';
    selectedCityId.value = null;
    v$.value.$reset();
  },
);

const resetValidation = () => {
  v$.value.$reset();
};

expose({ resetValidation });

return { __sfc: true,props, emit, getFullAddressStringFromAddressObj, cityAutocompleteRef, autocompleteRef, searchedCity, searchedAddress, fullAddress, selectedCityId, npProvider, citySuggestions, addressSuggestions, isCitiesLoading, isLocationsLoading, required, addressRules, errorMessages, v$, isAddressSelectDisabled, handleCityInput, handleAddressInput, searchCity, searchAddress, handleSelectCity, handleSelectAddress, resetValidation }
}

}